export default __webpack_public_path__ + "static/media/image02.81588ee5.png";